import { Button, Col, Form, Input, Modal, Row } from "antd";
import { useEffect, useState } from "react";
import FindUserOfInvoice from "../../functions/invoice/findUserOfInvoice";
import SyncAnimation from "../other/syncingSmaUser";
import AskUserPhone from "./askUserPhone";
import { useUser } from "../../screens/user/context.js/userContext";

const UserFinder = ({ open, close, invoiceId, done }) => {
    const { setPaying, paying } = useUser()
    const [askUserPhone, setAskUserPhone] = useState(false)
    useEffect(() => {
        if (invoiceId) {
            findUserOrCreate()
        }
    }, [invoiceId])
    const findUserOrCreate = async () => {
        setPaying('Хэрэглэгчийн мэдээлэл татаж байна...')
        const result = await FindUserOfInvoice(invoiceId)
        setPaying(null)
        if (result && result.success) {
            return done(result.data.userId)
        }
        setAskUserPhone(true)
    }
    const closeAskPhone = () => {
        setAskUserPhone(false)
    }
    const donePhone = async () => {
        findUserOrCreate()
    }
    if (askUserPhone) return <AskUserPhone open={askUserPhone} close={closeAskPhone} invoiceId={invoiceId} done={donePhone} />
    else return null
    // return (
    //     <Modal title={``} open={open} centered style={{ width: 300 }} closable={false} onCancel={close} footer={null}>
    //         <div style={{ height: 90 }}>
    //             {/* {paying && <SyncAnimation system1Logo={'/smaLogo.png'} system2Logo={'/card.png'} />} */}
    //             {askUserPhone && <AskUserPhone open={askUserPhone} close={closeAskPhone} invoiceId={invoiceId} done={donePhone} />}
    //         </div>
    //     </Modal>
    // );
}

export default UserFinder;


// user check: if invoice has phone find user by phone
// if user hasnot phone ask phone to pay

//if userId found||created check user has pin
//if user has pin ask pin and pay
//if user hasnot pin, set pin by verify phone and pay